import { useAuth, useHasRole } from '@/hooks/use-auth';
import { Outlet } from 'react-router-dom';
import {
  Home,
  Users,
  ClipboardList,
  CalendarDays,
  MessageSquare,
  CalendarClock,
  Megaphone,
  Trophy,
} from 'lucide-react';
import { AppSidebar, NavItem } from '@/components/layout/app-sidebar';

const navItems: NavItem[] = [
  { id: 'dashboard', href: '/coach', icon: Home, label: 'Dashboard' },
  { id: 'players', href: '/coach/players', icon: Users, label: 'Players' },
  { id: 'sessions', href: '/coach/sessions', icon: ClipboardList, label: 'Sessions' },
  { id: 'calendar', href: '/coach/calendar', icon: CalendarDays, label: 'Calendar' },
  { id: 'makeups', href: '/coach/makeups', icon: CalendarClock, label: 'Makeups' },
  { id: 'messages', href: '/coach/messages', icon: MessageSquare, label: 'Messages' },
  { id: 'announcements', href: '/coach/announcements', icon: Megaphone, label: 'Announcements' },
  { id: 'leaderboards', href: '/coach/leaderboards', icon: Trophy, label: 'Leaderboards' },
];

export default function CoachLayout() {
  const { user, logout, isLoading } = useAuth();
  const isAlsoDirector = useHasRole('director');

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-muted-foreground font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <AppSidebar
        navItems={navItems}
        bottomNavIds={['dashboard', 'sessions', 'players', 'calendar']}
        role="coach"
        portalName="Coach Portal"
        user={user}
        onLogout={logout}
        switchPortal={isAlsoDirector ? { label: 'Switch to Director Portal', href: '/director' } : undefined}
      >
        <Outlet />
    </AppSidebar>
  );
}
